module.exports = __webpack_public_path__ + "593a3d53/img/send-icon.3cfb6275.svg";